import { gql } from '@/clients/utoniq-core'

export const fragments = {
  credit: gql`
    fragment paymentCreateDetail on CreditCard {
      id
      name
      last4
      expMonth
      expYear
      brand
    }
  `,
  requiresAction: gql`
    fragment requiresActionDetail on RequiresAction {
      status
      clientSecret
    }
  `,
} as const
